_ = require("lodash")


class ClubFilterCtrl
  constructor: (@$scope, @GoogleMapLoaderService) ->
    @_clubs = []
    @_markers = []
    @_mostPlayedClub = undefined
    @_cachedLocation = undefined
    @GoogleMapLoaderService.load().then =>
      @$scope.$emit 'mapLoaded.gnp.analysis'
      @mapOptions =
        center: new google.maps.LatLng(0, 0)
        zoom: 2
        mapTypeId: google.maps.MapTypeId.ROADMAP

    @$scope.$on "clubsUpdated.gnp.analysis", (event, clubs) =>
      @_clearMap()
      @_clubs = clubs
      @_mostPlayedClub = @_findMostPlayedClub()
      @_renderNewMarkers()

    @$scope.$on "selectedCourseUpdated.gnp.analysis", (event, scorecard) =>
      return unless scorecard
      if @myMap
        @myMap.panTo new google.maps.LatLng scorecard.club.loc...
      else
        @_cachedLocation = scorecard.club.loc

    @$scope.$watch (=> @myMap), @_renderNewMarkers

  adjustMarkers: ->
    @_clearMap()
    @_addMarkers()

  _findMostPlayedClub: ->
   _.maxBy(@_clubs, 'count') || {}

  _addMarkers: ->
    _.forEach @_clubs, (club) => @_setMarker(club)

  _renderNewMarkers: =>
    loc = @_cachedLocation || @_mostPlayedClub?.loc
    return unless @myMap and loc
    @_addMarkers()
    @myMap.panTo new google.maps.LatLng loc...
    @myMap.setZoom 15

  _clearMap: ->
    _.forEach @_markers, (m) -> m.setMap(null)
    @_markers = []

  _setMarker: (club) ->
    pos = new google.maps.LatLng(club.loc[0], club.loc[1])
    maximumSize = (80 * @myMap.getZoom()) / 15
    fontSize = (18 * @myMap.getZoom()) / 15
    sizePerRound = maximumSize / @_mostPlayedClub.count
    size = (club.count.toString().length + 1) * 12
    size = size + "px"
    div = document.createElement('DIV')
    div.className = "circle"
    div.style.cssText = "width:#{size};height:#{size};font-size:#{fontSize}px;line-height:#{size}"
    div.innerHTML = club.count

    marker = new RichMarker
      id: club.id
      map: @myMap
      position: pos
      draggable: false
      flat: true
      anchor: RichMarkerPosition.MIDDLE
      content: div

    @_markers.push marker

ClubFilterCtrl.$inject = [
  '$scope'
  'GoogleMapLoaderService'
]

module.exports = ClubFilterCtrl




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/club-filter/club-filter-controller.coffee